import React from "react";
import PropTypes from 'prop-types';
import Button from '../Button';

export default class PurpleButton extends React.PureComponent {
    render() {
        let { className } = this.props;

        return (
            <Button {...this.props} className={`purple-button ${className ? className : ''}`} />
        );
    }
}

PurpleButton.propTypes = {
    className: PropTypes.string,
};
